import axios from "axios";

export const axiosInstance = axios.create({
  baseURL: `${process.env.REACT_APP_BASEURL}/api/v1` || "",
  withCredentials: true,
});

axiosInstance.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
}, (error) => {
  return Promise.reject(error);
});

const API_URL = "https://crmapi.automatebusiness.com/api/meta/v19.0";

export const sendTemplateMessage = async (message) => {
  const response = await axios.post(
    `${API_URL}/948906498298489/messages`,
    message,
    {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer 9o0Kz0gbNxFPP0RHLG7te72yBypAwREFTSAInH7yXzcVU5ERVJTQ09SRQ5Ygkqm87BaeGtSwdro8Bf2cOUglmq8zrOdLj8WqLFprXvh6YH6GG9EREFTSAnoMREFTSAPdcRYHxgy5cKZHpkREFTSA9Htezae8`,
      },
    }
  );

  return response.data;
};
